import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=0fddaf82&scoped=true&"
import script from "./Deals.vue?vue&type=script&lang=js&"
export * from "./Deals.vue?vue&type=script&lang=js&"
import style0 from "./Deals.vue?vue&type=style&index=0&id=0fddaf82&prod&scoped=true&lang=postcss&"
import style1 from "./Deals.vue?vue&type=style&index=1&id=0fddaf82&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fddaf82",
  null
  
)

export default component.exports